<script>
	import { gridPageType } from '../../../utils/utils.js';
	import { onMount } from 'svelte';
	import { Icon, DialogNew } from '@shopboxai/sb-portal-components';
	let type = 0;
	export let data;
	export let customProducts = [];
	let collections = [
		'new_for_you',
		'promotions_for_you',
		'recommendations',
		'recently_viewed',
		'previously_purchased',
		'find_similar',
		'frequently_bought_together',
		'custom_products'
	];
	let dynamicCollections = ['new_for_you', 'promotions_for_you', 'recommendations'];
	let fallbackCollections = [
		'top_viewed',
		'trending_view_products',
		'trending_order_products',
		'top_viewed_new_products',
		'top_viewed_offer_products',
		'top_order_products',
		'custom_products'
	];
	$: carouselDisabled =
		customProducts.length < 10 &&
		(data.data.collection == 'custom_products' || data.data.fallback == 'custom_products');
	onMount(() => {
		data.data.edit = true;
		data.data.type != 'banner' ? (type = 1) : (type = 0);
		data.data.type != 'banner'
			? data.data.collection == 'dynamic'
				? (type = 2)
				: (type = 1)
			: (type = 0);
	});
</script>

<DialogNew on:submit on:close topLevel={true} maxWidth={'600px'}>
	<div slot="toggle" title="Edit item"><Icon name="settings" /></div>

	<div slot="header">Edit element</div>
	<button class="primary" slot="primary-action">Apply </button>
	<div slot="content" class="dialog-form-wrapper">
		<div class="dialog-form-type dialog-form-type-extended">
			<button
				disabled={type != 0}
				on:click|preventDefault={() => (type = 0)}
				class="dialog-type-box"
				class:active={type == 0}
			>
				<Icon name="image" />
				<p>Banner</p>
			</button>
			<button
				disabled={type != 1}
				on:click|preventDefault={() => (type = 1)}
				class="dialog-type-box"
				class:active={type == 1}
			>
				<Icon name="collection" />
				<p>Product collection</p>
			</button>

			<button
				disabled={type != 2}
				on:click|preventDefault={() => (type = 2)}
				class="dialog-type-box"
				class:active={type == 2}
			>
				<Icon name="collection" />
				<p>Contextual collection</p>
			</button>
		</div>
		<label for="title">Title</label>
		<input id="title" type="text" bind:value={data.data.title} />
		{#if type == 0}
			<div class="dialog-form-banner ">
				<label for="action">Action URL</label>
				<input id="action" type="text" bind:value={data.data.url} required />
				<label for="image">Image URL</label>
				<input id="image" type="text" bind:value={data.data.image_url} required />
			</div>
		{:else if type == 1}
			<div class="dialog-form-product-collection ">
				<label for="collection">Dynamic Product collection</label>
				<select
					bind:value={data.data.collection}
					on:change={() => {
						if (carouselDisabled) data.data.num_products = 3;
					}}
					required
				>
					<optgroup label="Dynamic Collections">
						{#each collections as collection}
							{#if collection == 'find_similar' && $gridPageType !== 'productDetails'}
								<option value={collection} disabled>{collection}</option>
							{:else if collection == 'frequently_bought_together' && $gridPageType !== 'productDetails' && $gridPageType !== 'cart'}
								<option value={collection} disabled>{collection}</option>
							{:else}
								{$gridPageType}
								<option value={collection}>{collection}</option>
							{/if}
						{/each}

						<option value="dynamic">Context Aware</option>
						<option value="search">Search</option>
					</optgroup>

					<optgroup label="Static Collections">
						{#each fallbackCollections as collection}
							<option value={collection}>{collection}</option>
						{/each}
					</optgroup>
				</select>
				<label for="fallback-title">Static Collection Title</label>
				<input id="fallback-title" type="text" bind:value={data.data.fallback_title} required />
				<label for="collection">Static Product Collection</label>
				<select
					bind:value={data.data.fallback}
					on:change={() => {
						if (carouselDisabled) data.data.num_products = 3;
					}}
					required
				>
					{#each fallbackCollections as collection}
						<option value={collection}>{collection}</option>
					{/each}
				</select>
				<p class="radio-heading">Number of products</p>
				<div class="radio-wrapper">
					<input
						type="radio"
						name="select"
						bind:group={data.data.num_products}
						id="num-1"
						value={1}
						checked
					/>
					<label for="num-1" class="radio-label">1</label>
					<input
						type="radio"
						name="select"
						disabled={data.data.device == 'mobile'}
						bind:group={data.data.num_products}
						id="num-3"
						value={3}
					/>
					<label for="num-3" class="radio-label">3</label>
					<input
						type="radio"
						name="select"
						id="num-4"
						bind:group={data.data.num_products}
						value={4}
					/>
					<label for="num-4" class="radio-label">4</label>
					<input
						type="radio"
						name="select"
						id="num-12"
						disabled={carouselDisabled}
						bind:group={data.data.num_products}
						value={12}
					/>
					<label for="num-12" class="radio-label">12 (Carousel)</label>
				</div>
			</div>
		{:else if type == 2}
			<div class="dialog-form-product-collection ">
				<label for="collection">Dynamic Product collection</label>
				<select
					bind:value={data.data.collection_filter}
					on:change={() => {
						if (carouselDisabled) data.data.num_products = 3;
					}}
					required
				>
					<optgroup label="Dynamic Collections">
						{#each dynamicCollections as collection}
							<option value={collection}>{collection}</option>
						{/each}
					</optgroup>

					<optgroup label="Static Collections">
						{#each fallbackCollections as collection}
							<option value={collection}>{collection}</option>
						{/each}
					</optgroup>
				</select>
				<label for="fallback-title">Static Collection Title</label>
				<input id="fallback-title" type="text" bind:value={data.data.fallback_title} required />
				<label for="collection">Static Product Collection</label>
				<select
					bind:value={data.data.fallback}
					on:change={() => {
						if (carouselDisabled) data.data.num_products = 3;
					}}
					required
				>
					{#each fallbackCollections as collection}
						<option value={collection}>{collection}</option>
					{/each}
				</select>
				<p class="radio-heading">Number of products</p>
				<div class="radio-wrapper">
					<input
						type="radio"
						name="select"
						bind:group={data.data.num_products}
						id="num-1"
						value={1}
						checked
					/>
					<label for="num-1" class="radio-label">1</label>
					<input
						type="radio"
						name="select"
						disabled={data.data.device == 'mobile'}
						bind:group={data.data.num_products}
						id="num-3"
						value={3}
					/>
					<label for="num-3" class="radio-label">3</label>
					<input
						type="radio"
						name="select"
						id="num-4"
						bind:group={data.data.num_products}
						value={4}
					/>
					<label for="num-4" class="radio-label">4</label>
					<input
						type="radio"
						name="select"
						id="num-12"
						disabled={carouselDisabled}
						bind:group={data.data.num_products}
						value={12}
					/>
					<label for="num-12" class="radio-label">12 (Carousel)</label>
				</div>
			</div>
		{/if}
	</div>
</DialogNew>

<style>
	.dialog-form-wrapper {
		min-height: 360px;
	}
	.dialog-form-type {
		display: grid;
		grid-gap: 1em;
		grid-template-columns: 1fr 1fr;
		margin-bottom: 1em;
	}
	.dialog-form-type-extended {
		grid-template-columns: 1fr 1fr 1fr;
	}
	.dialog-type-box {
		display: grid;
		place-content: center;
		text-align: center;
		padding: 14px 12px;
		border: 1px solid #727178;
		box-sizing: border-box;
		border-radius: 3px;
		cursor: pointer;
	}
	.dialog-type-box.active {
		border-color: #091eb5;
		background: var(--bg-c);
		color: #091eb5;
	}
	.dialog-type-box.active :global(svg > *) {
		stroke: #091eb5;
	}
	.radio-wrapper {
		display: grid;
		grid-auto-flow: column;
		margin-bottom: 0.5em;
	}
	.radio-label {
		border: 1px solid #727178;
		padding: 8px;
		text-align: center;
		cursor: pointer;
	}
	input[type='radio'] {
		display: none;
	}
	input[type='radio']:checked + label {
		border-color: #0069d9;
		background: var(--bg-c);
		color: #091eb5;
	}
	input[type='radio']:disabled + label {
		opacity: 0.5;
		cursor: no-drop !important;
	}
</style>
